import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Insurer.Insurer_Minimal}
    mutation UpdateInsurer($id: ID!, $title: String!, $phone: String, $email: String) {
        updateInsurer(input: { id: $id, title: $title, phone: $phone, email: $email }) {
            errors
            status
            statusCode
            insurer {
                ...Insurer_Minimal
            }
        }
    }
`
